export default __webpack_public_path__ + "static/media/movie_alternate.877853df.jpg";